import { RateData } from "../types";

export interface ResolvedScheduleDates {
  startDate: Date | null;
  endDate: Date | null;
}

type ScheduleFields = Pick<
  RateData,
  "isScheduled" | "salesStartMode" | "salesStartDate" | "salesStartAfterRateId" | "salesEndMode" | "salesEndDate"
>;

export type ReferenceRateScheduleFields = Pick<RateData, "id" | "isScheduled" | "salesEndMode" | "salesEndDate">;

export const resolveScheduleDates = (
  rate: ScheduleFields,
  allRates: ReferenceRateScheduleFields[]
): ResolvedScheduleDates => {
  if (!rate.isScheduled) {
    return { startDate: null, endDate: null };
  }

  const endDate = rate.salesEndMode === "customDate" && rate.salesEndDate ? new Date(rate.salesEndDate) : null;

  const referencedRate =
    rate.salesStartMode === "afterRate" && rate.salesStartAfterRateId
      ? allRates.find((candidate) => candidate.id === rate.salesStartAfterRateId)
      : undefined;
  const referencedEndDate =
    referencedRate?.isScheduled && referencedRate.salesEndMode === "customDate" && referencedRate.salesEndDate
      ? new Date(referencedRate.salesEndDate)
      : null;

  const startDate =
    rate.salesStartMode === "customDate" && rate.salesStartDate ? new Date(rate.salesStartDate) : referencedEndDate;

  return { startDate, endDate };
};

export interface EventEndSource {
  endUtc?: Date | string | null;
  closeDate?: Date | string | null;
  repeatUntilDate?: Date | string | null;
  isHidden?: boolean | null;
}

export const resolveEventEndDate = (recurrences: EventEndSource[] | undefined): Date | null => {
  const ends = (recurrences ?? [])
    .filter((recurrence) => !recurrence.isHidden)
    .map((recurrence) => recurrence.closeDate ?? recurrence.repeatUntilDate ?? recurrence.endUtc)
    .filter((end): end is Date | string => Boolean(end))
    .map((end) => new Date(end).getTime());
  return ends.length ? new Date(Math.max(...ends)) : null;
};
